module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/SD-card-c8ee95059e58b9b3c657b5acbbd70462.svg";